import { forwardRef } from "react";
import { BaseInputProps } from "@talladega/types";
import { BaseInput } from "../form";
import { getInputStyles, getBaseInputProps } from "../helpers";

// eslint-disable-next-line no-underscore-dangle
const _Input = forwardRef<HTMLInputElement, BaseInputProps>(
  (
    {
      type = "text",
      id,
      disabled,
      leftIcon,
      rightIcon,
      className,
      suppressHotjar,
      fieldError,
      onChange,
      ...props
    },
    ref
  ) => {
    const baseInputProps = getBaseInputProps({
      type,
      disabled,
      leftIcon,
      rightIcon,
      status: fieldError ? "error" : "default",
      feedback: fieldError?.message,
      ...props,
    });
    const inputClassName = getInputStyles({
      leftIcon: baseInputProps.leftIcon,
      rightIcon: baseInputProps.rightIcon,
      border: baseInputProps.border,
      placeholderSize: baseInputProps.placeholderSize,
      status: baseInputProps.status,
      cursor: baseInputProps.cursor,
      spacing: baseInputProps.spacing,
    });
    return (
      <BaseInput id={id} className={className} {...baseInputProps}>
        <input
          id={id}
          className={inputClassName}
          type={type}
          disabled={disabled}
          ref={ref}
          data-hj-allow={(!suppressHotjar && type === "text") || undefined}
          onChange={(e) => {
            e.target.value = e.target.value.trimStart();
            if (onChange) onChange(e);
          }}
          {...props}
        />
      </BaseInput>
    );
  }
);

export default _Input;
